module.exports = __webpack_public_path__ + "media/images/contest-voted-story@3x-7d5378d38c186ce65962d03860d496df.png";